import { Component } from '@angular/core';

@Component({
  selector: 'app-nextday',
  template: `
    <input
      type="text"
      maxlength="1"
      [(ngModel)]="value"
      class="grid-cell-edit-layout"
      [ngClass]="{ 'invalid-text': isInvalid }"
      (input)="textUpdated()"
      (keydown)="onKeyPress($event)"
    />
  `,
  styles: [
    `
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      .grid-cell-edit-layout {
        width: 123px;
        height: 26px;
        border: 1px solid #d1d1d1;
      }
      .invalid-text {
        border: 2px solid red !important;
      }
    `,
  ],
})
export class editNextday {
  public params: any;
  value: string = '';
  value2: string = '';
  isInvalid: boolean = false;
  originalDayOffset;
  agInit(params: any): void {
    this.params = params;
    params.data.isnextday = this;
    
    // Store the original value of day_offset
    this.originalDayOffset = params.data.day_offset;

    const offset = params.data.day_offset;
    this.value = (offset == '0' || offset == 0) ? 'N' : 'Y';
    this.value2 = offset;
}


  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  public textUpdated() {
    console.log('Day Offset updated:', this.value); // Debugging log

    if (this.params.column === 'day_offset') {
        if (this.value === 'Y' || this.value === 'y') {
            this.params.data.day_offset = '1';
            this.params.data.value2 = 'Y';
        } else {
            this.params.data.day_offset = '0';
            this.params.data.value2 = 'N';
        }

        // Set a flag to indicate this row is modified
        if (this.params.data.day_offset !== this.originalDayOffset) {
            this.params.data.isDayoffset = true; // Mark it as modified
        } else {
            this.params.data.isDayoffset = false; // No modification
        }
    }
}


  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Y', 'N', 'y', 'n', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    const isControlKey = event.ctrlKey || event.metaKey;

    if (!allowedKeys.includes(event.key) && !isControlKey) {
      event.preventDefault();
    }
  }
}
